import React from "react";
import { Select } from "./Select";
import { SelectId } from "./SelectId";

const discountOptionsDefault = [
    { id: 0, label: '0%' },
    { id: 5, label: '5%' },
    { id: 10, label: '10%' },
    { id: 15, label: '15%' },
    { id: 16, label: '16%' },
    { id: 20, label: '20%' },
    { id: 23, label: '23%' },
    { id: 25, label: '25%' },
    { id: 30, label: '30%' },
    { id: 35, label: '35%' },
    { id: 40, label: '40%' }
];

const generateDiscountOptions = (start, end, step = 1) => {
    const options = [];
    for (let i = start; i <= end; i += step) {
        options.push({ id: i, label: `${i}%` });
    }
    return options;
};

const getUUSDiscountOptions = (uusEnhancedDiscount) => {
    return uusEnhancedDiscount
        ? generateDiscountOptions(0, 15, 1).concat(generateDiscountOptions(16, 23, 1)) 
        : generateDiscountOptions(0, 15, 1); 
};


export const CampaignDiscountSelect = (props) => {
    const discountOptions = props.salesTeam?.prefix === "UUS"
        ? getUUSDiscountOptions(props.uusEnhancedDiscount)
        : discountOptionsDefault;


    return (props.valueIsId ? <SelectId options={discountOptions} {...props} labelField="label" /> : <Select options={discountOptions} {...props} labelField="label" />);
}
